import "./home.scss";
import { MapContainer, TileLayer, LayerGroup } from "react-leaflet";
import { Link } from "react-router-dom";
import Select from "react-select";
import { BsChevronLeft } from "react-icons/bs";

import React, { useState, useEffect } from "react";
import makeAnimated from "react-select/animated";

import { useSelector, useDispatch } from "react-redux";
import {
  getorganization,
  getknowledge,
  getimpact,
  getgoal,
  getknowledgeMap,
} from "../redux/home/action";

import ResultDetail from "./ResultDetail";
import D3Layer from "./Map/D3Layer";
import MapDetail from "./Map/MapDetail";
import CardCount from "./CardCount";

export default function Knowledge(props) {
  const { page, value } = props;
  const animatedComponents = makeAnimated();
  const [campus, setcampus] = useState(value);
  const [Knowledge, setKnowledge] = useState(value);
  const [impact, setimpact] = useState(value);
  const [goal, setgoal] = useState(value);

  const [campusName, setcampusName] = useState("");
  const [KnowledgeName, setKnowledgeName] = useState("");
  const [impactName, setimpactName] = useState("");
  const [goalName, setgoalName] = useState("");

  const [title, settitle] = useState("");

  const getTitle = () => {
    if (page === "knowledge") {
      settitle("องค์ความรู้และนวัตกรรม Knowledge and Innovation");
    } else if (page === "goal") {
      settitle("เป้าหมายเพื่อการพัฒนา Development Goal");
    } else if (page === "impact") {
      settitle("การแสดงผลผลกระทบ Impact Monitoring");
    } else if (page === "newknowledge") {
      settitle("องค์ความรู้ใหม่ New Knowledge");
    }
  };

  const dispatch = useDispatch();
  const statehome = useSelector((state) => state.statehome);
  const map = useSelector((state) => state.statehome.knowledgeMap);
  const DataChart = useSelector((state) => state.statehome.knowledgeChart);

  const handleChangeCampus = (e) => {
    if (e) {
      setcampus(e.value);
      dispatch(getknowledgeMap(e.value, Knowledge, impact, goal, page));
      setcampusName(e.label);
    } else {
      setcampus("");
      dispatch(getknowledgeMap("", Knowledge, impact, goal, page));
      setcampusName("");
    }
  };
  const handleChangeKnowledge = (e) => {
    if (e) {
      setKnowledge(e.value);
      dispatch(getknowledgeMap(campus, e.value, impact, goal, page));
      setKnowledgeName(e.label);
    } else {
      setKnowledge("");
      setKnowledgeName("");
      dispatch(getknowledgeMap(campus, "", impact, goal, page));
    }
  };
  const handleChangeImpact = (e) => {
    if (e) {
      setimpact(e.value);
      dispatch(getknowledgeMap(campus, Knowledge, e.value, goal, page));
      setimpactName(e.label);
    } else {
      setimpact("");
      setimpactName("");
      dispatch(getknowledgeMap(campus, Knowledge, "", goal, page));
    }
  };
  const handleChangeGoal = (e) => {
    if (e) {
      setgoal(e.value);
      dispatch(getknowledgeMap(campus, Knowledge, impact, e.value, page));
      setgoalName(e.label);
    } else {
      setgoal("");
      setgoalName("");
      dispatch(getknowledgeMap(campus, Knowledge, impact, "", page));
    }
  };

  useEffect(() => {
    dispatch(getorganization());
    dispatch(getknowledge());
    dispatch(getimpact());
    dispatch(getgoal());
    dispatch(getknowledgeMap(campus, Knowledge, impact, goal, page));
    getTitle();
  }, [page]);

  console.log("Map", map);
  console.log("knowledgeChart", DataChart);

  return (
    <div className="home">
      <div className="title-name">
        {page === "knowledge" ? (
          <h5>{title}</h5>
        ) : (
          <>
            <h5>{title}</h5>
            <a href="/Knowledge/">
              <p>
                <BsChevronLeft />
                Back
              </p>
            </a>
          </>
        )}
      </div>
      <div className="map-home">
        <div className="dropdown-map">
          <div className="dropdown-map-li">
            <Select
              placeholder="เลือกวิทยาเขต"
              className="basic-single"
              classNamePrefix="select"
              components={animatedComponents}
              isClearable={true}
              options={statehome.organization}
              onChange={(e) => handleChangeCampus(e)}
            />
          </div>

          <div className="dropdown-map-li">
            <Select
              placeholder="เลือกประเภทองค์ความรู้"
              className="basic-single"
              classNamePrefix="select"
              components={animatedComponents}
              isClearable={true}
              options={statehome.knowledge}
              onChange={(e) => handleChangeKnowledge(e)}
            />
          </div>
          <div className="dropdown-map-li">
            <Select
              placeholder="เลือกประเภทผลกระทบ"
              className="basic-single"
              classNamePrefix="select"
              components={animatedComponents}
              isClearable={true}
              options={statehome.impact}
              onChange={(e) => handleChangeImpact(e)}
            />
          </div>
          <div className="dropdown-map-li">
            <Select
              placeholder="เลือกประเภทกลุ่มเป้าหมาย"
              className="basic-single"
              classNamePrefix="select"
              components={animatedComponents}
              isClearable={true}
              options={statehome.goal}
              onChange={(e) => handleChangeGoal(e)}
            />
          </div>
        </div>

        <MapContainer
          center={[14.947, 103.793]}
          zoom={6}
          scrollWheelZoom={true}
          zoomControl={false}
          style={{
            width: "100%",
            height: "100%",
            margin: "0",
            zIndex: "0",
            borderRadius: "15px",
          }}
        >
          <TileLayer
            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />

          <LayerGroup>
            {Object.keys(map).length > 1 ? <D3Layer location={map} /> : null}
          </LayerGroup>

          <div className="menu-map">
            <div className="menu-map-li  ">
              <a href="/Knowledge/" className="knowledge">
                <p className={page}>
                  Knowledge and Innovation (องค์ความรู้และนวัตกรรม)
                </p>
              </a>
            </div>
            <div className="menu-map-li ">
              <a href="/Knowledge/goal" className="goal">
                <p className={page}>Development Goal (เป้าหมายเพื่อการพัฒนา)</p>
              </a>
            </div>
            <div className="menu-map-li">
              <a href="/Knowledge/impact" className="impact">
                <p className={page}>Impact Monitoring (การแสดงผลกระทบ)</p>
              </a>
            </div>
            <div className="menu-map-li">
              <a href="/Knowledge/newknowledge" className="newknowledge">
                <p className={page}>New Knowledge (องค์ความรู้ใหม่)</p>
              </a>
            </div>
            <MapDetail page={page} />
          </div>
        </MapContainer>
      </div>

      <div
        className="dashboard"
        style={{ marginTop: "-4.5rem", marginBottom: "-1rem" }}
      >
        <CardCount page={page} />
        <ResultDetail
          title={title}
          page={page}
          campusName={campusName}
          KnowledgeName={KnowledgeName}
          impactName={impactName}
          goalName={goalName}
          campus={campus}
          Knowledge={Knowledge}
          impact={impact}
          goal={goal}
        />
      </div>
    </div>
  );
}
